<section class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Customer Search</h1>
    <app-navpath class="hidden md:block" />
  </div>

  <div class="content-container">
    <h2 class="sub-heading w-full border-b">Buyer's Details</h2>
    <app-data-form
      [dataFields]="searchFields"
      [dataName]="'search'"
      class="w-full border-b"
      (clickSearch)="onSearch($event)"
      (updateFields_child)="updateFields($event)"
    />
    <div class="flex flex-col gap-1 md:flex-row">
      <button
        class="shorter-btn save-btn"
        [disabled]="lockUpdate"
        (click)="update()"
      >
        <fa-icon [icon]="faEdit" class="mr-1" />Update
      </button>
      <button
        class="shorter-btn print-btn"
        [disabled]="lockPrint"
        (click)="print()"
      >
        <fa-icon [icon]="faPrint" class="mr-1" />Print Sales Contract
      </button>
    </div>
  </div>
  <div class="content-container">
    <h2 class="sub-heading w-full border-b">
      Buyer's Details Based On Model
    </h2>
    <div
      class="flex max-w-xl flex-col items-center gap-4 md:flex-row"
    >
      <app-data-form
        [dataFields]="modelForm"
        [dataName]="'modelForm'"
        class="flex-grow"
        [columns]="1"
        (updateFields_child)="updateModelFields($event.fields)"
      />
      <button
        class="shorter-btn add-btn self-start md:w-full"
        (click)="onDownloadCustomerList()"
        [disabled]="!selectedModelId"
      >
        <fa-icon [icon]="faDownload" class="mr-1" />Download Customer
        List
      </button>
    </div>
  </div>
  <div *ngIf="tableData.length > 0" class="content-container">
    <h2 class="sub-heading w-full border-b mb-4">Search Results</h2>
    <app-data-table
      [tableHeaders]="tableHeaders"
      [tableEntries]="tableData"
      [pagination]="false"
    />
  </div>
</section>
